import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Router from 'router';
import { route } from 'router';
import { Modal, Text, Button, Link } from 'components-guide';
import Storage from 'services/storage.service';
import CookiesService from 'services/cookies.service';

import './Cookies.scss';

export interface CookiesProps {
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
}

const COOKIES = { technical: true, personalization: true, publicity: true, analytics: true };

const Cookies: React.FC<CookiesProps> = ({ className, style }) => {
    const { t } = useTranslation();
    const [cookies, setCookies] = useState(false);
    const classNames = classnames(['cookies', className]);

    const getCookies = () => Storage.get({ key: Storage.keys.cookies });

    useEffect(() => {
        const cookies = getCookies()
        setCookies(!cookies);
        CookiesService.initialize(cookies || {});
    }, []);

    const handleOnClickConfig = () => Router.push({ pathname: route.app.legal.cookies() });
    const handleOnClickAccept = () => {
        setCookies(false);
        CookiesService.initialize(COOKIES);
        Storage.set({ key: Storage.keys.cookies, value: COOKIES });
    };

    return (
        <div className={classNames} style={style}>
            <Modal opened={cookies}>
                <div className="cookies__wrapper screen__wrapper">
                    <div className="cookies__text flex-1">
                        <Text weight="bold">{t('components.cookies.title')}</Text>
                        <Text typo="small-xs" className="mb-0">
                            {t('components.cookies.description')}{' '}
                            <Link onClick={handleOnClickConfig}>{t('components.cookies.link')}</Link>.
                        </Text>
                    </div>
                    <div className="cookies__actions">
                        <Link underline color="primary" className="mr-3" onClick={handleOnClickConfig}>
                            {t('components.cookies.btnConfig')}
                        </Link>
                        <Button onClick={handleOnClickAccept}>{t('components.cookies.btnAccept')}</Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Cookies;
